import { Component } from '@angular/core';
import { environment } from '../../environments/environment';

declare const UC_UI: any;

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
    public version = environment.version;
    currentYear: number = new Date().getFullYear();
    isCookiesScriptLoaded = false;

    constructor() {
        this.cookiesScriptHandler();
    }
    onCookies(): void {
        UC_UI.showSecondLayer();
    }

    private cookiesScriptHandler() {
        if (!window) {
            return;
        }

        if ((<any>window)['UC_UI'] !== undefined) {
            this.isCookiesScriptLoaded = true;
            return;
        }

        window.addEventListener('UC_UI_INITIALIZED', (event) => {
            if (event) {
                this.isCookiesScriptLoaded = true;
            }
        });
    }
}
